import MediaUpload from './MediaUpload';

export default MediaUpload;
